import { render, staticRenderFns } from "./QuillToolbar.vue?vue&type=template&id=35910a16&"
import script from "./QuillToolbar.vue?vue&type=script&lang=js&"
export * from "./QuillToolbar.vue?vue&type=script&lang=js&"
import style0 from "./QuillToolbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports